import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import {
  CommentOverviewRecord,
  CommentRecord,
  ExpertEventNotificationRecord,
} from '@libs/shared/api';
import { ExpertEventNotificationWrapperComponent } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification-wrapper.component';
import { injectExpertEventNotificationService } from '@sprint-expert/app/modules/expert-event-notification/expert-event-notification.service';
import { ExpertMemberTitlePipe } from '@sprint-expert/app/utils/pipe/expert-member-title.pipe';

@Component({
  selector: 'app-expert-session-schedule-created-notification',
  standalone: true,
  imports: [
    CommonModule,
    ExpertEventNotificationWrapperComponent,
    ExpertMemberTitlePipe,
  ],
  template: `
    <app-expert-event-notification-wrapper
      class="cursor-pointer"
      (click)="onClick()"
      [notification]="notification"
      title="수업 일정을 예약했어요.">
      <div class="text-secondary">
        <p>
          회원명:
          {{ notification.expertSession.expertMember | expertMemberTitle }}
        </p>
        <p>
          수업일자: {{ notification.expertSession.startedAt | date: 'short' }}
        </p>
        <p>수업시간: {{ notification.expertSession.duration }}분</p>
      </div>
    </app-expert-event-notification-wrapper>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertSessionScheduleCreatedNotificationComponent {
  readonly vm = injectExpertEventNotificationService();
  readonly router = inject(Router);

  @Input({ required: true })
  notification: ExpertEventNotificationRecord;

  onClick() {
    this.vm.readExpertEventNotification(this.notification);
    this.router.navigate(
      [
        'expert-workspace',
        this.vm.currentExpertWorkspace$$().id,
        'expert-schedule',
      ],
      {
        onSameUrlNavigation: 'reload',
      }
    );
  }
}
